module.exports = __webpack_public_path__ + "static/media/fonction.3d32b9e4.png";